//  该类封装公共数组处理工具，调用方式：vm.tool.array.format(new Date(), "yyyy-MM-dd")

class ArrayTool {
}

export default new ArrayTool()
